import {
  getLocaleSettings as publicGetLocaleSettings,
  updateLocaleSettings as publicUpdateLocaleSettings,
  setMultilingualMode as publicSetMultilingualMode,
} from './multilingual-settings-v2-locale-settings-locale-settings.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import {
  BuildRESTFunction,
  MaybeContext,
  BuildEventDefinition,
} from '@wix/sdk-types';
import { onLocaleSettingsCreated as publicOnLocaleSettingsCreated } from './multilingual-settings-v2-locale-settings-locale-settings.public.js';
import { onLocaleSettingsDeleted as publicOnLocaleSettingsDeleted } from './multilingual-settings-v2-locale-settings-locale-settings.public.js';
import { onLocaleSettingsMultilingualModeUpdated as publicOnLocaleSettingsMultilingualModeUpdated } from './multilingual-settings-v2-locale-settings-locale-settings.public.js';
import { onLocaleSettingsUpdated as publicOnLocaleSettingsUpdated } from './multilingual-settings-v2-locale-settings-locale-settings.public.js';

export const getLocaleSettings: MaybeContext<
  BuildRESTFunction<typeof publicGetLocaleSettings> &
    typeof publicGetLocaleSettings
> = /*#__PURE__*/ createRESTModule(publicGetLocaleSettings);
export const updateLocaleSettings: MaybeContext<
  BuildRESTFunction<typeof publicUpdateLocaleSettings> &
    typeof publicUpdateLocaleSettings
> = /*#__PURE__*/ createRESTModule(publicUpdateLocaleSettings);
export const setMultilingualMode: MaybeContext<
  BuildRESTFunction<typeof publicSetMultilingualMode> &
    typeof publicSetMultilingualMode
> = /*#__PURE__*/ createRESTModule(publicSetMultilingualMode);
/**
 * Triggered when the site is created.
 */
export const onLocaleSettingsCreated: BuildEventDefinition<
  typeof publicOnLocaleSettingsCreated
> &
  typeof publicOnLocaleSettingsCreated = createEventModule(
  publicOnLocaleSettingsCreated
);
/**
 * Triggered when the site is deleted.
 */
export const onLocaleSettingsDeleted: BuildEventDefinition<
  typeof publicOnLocaleSettingsDeleted
> &
  typeof publicOnLocaleSettingsDeleted = createEventModule(
  publicOnLocaleSettingsDeleted
);
/**
 * Triggered when the site's multilingual mode is updated.
 */
export const onLocaleSettingsMultilingualModeUpdated: BuildEventDefinition<
  typeof publicOnLocaleSettingsMultilingualModeUpdated
> &
  typeof publicOnLocaleSettingsMultilingualModeUpdated = createEventModule(
  publicOnLocaleSettingsMultilingualModeUpdated
);
/**
 * Triggered when locale settings are updated.
 */
export const onLocaleSettingsUpdated: BuildEventDefinition<
  typeof publicOnLocaleSettingsUpdated
> &
  typeof publicOnLocaleSettingsUpdated = createEventModule(
  publicOnLocaleSettingsUpdated
);

export {
  UrlStructure,
  LocaleVisibility,
  State,
  SiteCreatedContext,
  Namespace,
  DeleteStatus,
  SortOrder,
  WebhookIdentityType,
} from './multilingual-settings-v2-locale-settings-locale-settings.universal.js';
export {
  LocaleSettings,
  Locale,
  UrlStructureOverride,
  MultilingualModeUpdated,
  GetLocaleSettingsRequest,
  GetLocaleSettingsResponse,
  UpdateLocaleSettingsRequest,
  UpdateLocaleSettingsResponse,
  SetMultilingualModeRequest,
  SetMultilingualModeResponse,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  Empty,
  MetaSiteSpecialEvent,
  MetaSiteSpecialEventPayloadOneOf,
  Asset,
  SiteCreated,
  SiteTransferred,
  SiteDeleted,
  DeleteContext,
  SiteUndeleted,
  SitePublished,
  SiteUnpublished,
  SiteMarkedAsTemplate,
  SiteMarkedAsWixSite,
  ServiceProvisioned,
  ServiceRemoved,
  SiteRenamed,
  SiteHardDeleted,
  NamespaceChanged,
  StudioAssigned,
  StudioUnassigned,
  SiteUrlChanged,
  SitePurgedExternally,
  OdeditorAssigned,
  OdeditorUnassigned,
  PicassoAssigned,
  PicassoUnassigned,
  WixelAssigned,
  WixelUnassigned,
  StudioTwoAssigned,
  StudioTwoUnassigned,
  UserDomainMediaEnabled,
  UserDomainMediaDisabled,
  EditorlessAssigned,
  EditorlessUnassigned,
  QueryLocaleSettingsRequest,
  CursorQuery,
  CursorQueryPagingMethodOneOf,
  Sorting,
  CursorPaging,
  QueryLocaleSettingsResponse,
  CursorPagingMetadata,
  Cursors,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  BaseEventMetadata,
  EventMetadata,
  AccountInfoMetadata,
  LocaleSettingsCreatedEnvelope,
  LocaleSettingsDeletedEnvelope,
  LocaleSettingsMultilingualModeUpdatedEnvelope,
  LocaleSettingsUpdatedEnvelope,
} from './multilingual-settings-v2-locale-settings-locale-settings.universal.js';
export {
  UrlStructureWithLiterals,
  LocaleVisibilityWithLiterals,
  StateWithLiterals,
  SiteCreatedContextWithLiterals,
  NamespaceWithLiterals,
  DeleteStatusWithLiterals,
  SortOrderWithLiterals,
  WebhookIdentityTypeWithLiterals,
  SetMultilingualModeApplicationErrors,
} from './multilingual-settings-v2-locale-settings-locale-settings.universal.js';
